import { createFileRoute } from "@tanstack/react-router"
import { z } from "zod"
import { consumeSsoTicketFn } from "@/auth/rpc/sso"

const searchSchema = z.object({
  ticket: z.string().optional(),
  redirectTo: z.string().optional(),
})

/**
 * Consumes an SSO ticket minted by the sister app and establishes a local session.
 */
export const Route = createFileRoute("/sso/consume")({
  validateSearch: (search) => searchSchema.parse(search),
  beforeLoad: async ({ search }) => {
    await consumeSsoTicketFn({
      data: {
        ticket: search.ticket,
        redirectTo: search.redirectTo,
      },
    })
  },
})
